export default function () {
    const state = {};
    return {
        get: (key) => {
            return state[key];
        },
        set: (key, value) => {
            state[key] = value;
        }
    };
}
